import React, { FunctionComponent, ReactNode } from 'react';
import { useStepper } from '../../../../hooks';
import { mainMediaMobile } from '../../../../utils';
import useMediaQuery from '../../../../hooks/use-media';
import classNames from '../../../../utils/classnames';
import { AccordionItem, Box } from '@chakra-ui/react';

interface StepperStepProps {
  children: ReactNode;
  id: number;
  title?: string;
  hide?: boolean;
}

export const StepperStep: FunctionComponent<StepperStepProps> = ({ children, id, hide }) => {
  const { steps } = useStepper();
  const { isActive, isTouched, isValid } = steps[id];
  const isMobile = useMediaQuery(mainMediaMobile);

  const classes = classNames('stepper__step', {
    hidden: (!isActive && isMobile) || hide,
    'stepper__step--is-valid': isValid,
    'stepper__step--is-touched': isTouched
  });

  return (
    <AccordionItem>
      <Box
        className={`md:rounded md:shadow md:shadow-shadow-500 md:bg-white mb-4 md:px-[1rem] ${classes}`}>
        {children}
      </Box>
    </AccordionItem>
  );
};
